import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardHeader, CardTitle } from '@produzionejb/ui';
import { useStockMovements } from '../../../lib/stock-movements-api';
import { useCurrentPeriod } from '../../../lib/periods-api';

export function MovementsInMonthWidget() {
  const { t } = useTranslation();
  const periodQ = useCurrentPeriod();
  const movsQ = useStockMovements(
    { periodId: periodQ.data?.id, direction: 'IN', pageSize: 50 },
    !!periodQ.data?.id,
  );

  const items = movsQ.data?.items ?? [];

  return (
    <Card>
      <CardHeader>
        <CardTitle>
          {t('dashboard.movementsIn.title')}
          {movsQ.data && <span className="ml-2 text-sm text-slate-500">({movsQ.data.total})</span>}
        </CardTitle>
      </CardHeader>
      <CardContent>
        {(periodQ.isLoading || movsQ.isLoading) && (
          <p className="text-sm text-slate-500">{t('common.loading')}</p>
        )}
        {!movsQ.isLoading && items.length === 0 && (
          <p className="text-sm text-slate-500">{t('dashboard.movementsIn.empty')}</p>
        )}
        {items.length > 0 && (
          <div className="max-h-72 overflow-y-auto">
            <table className="w-full text-xs">
              <thead className="border-b border-slate-200 bg-slate-50">
                <tr>
                  <th className="px-2 py-1 text-left font-medium text-slate-600">
                    {t('dashboard.movementsIn.col.date')}
                  </th>
                  <th className="px-2 py-1 text-left font-medium text-slate-600">
                    {t('dashboard.movementsIn.col.lot')}
                  </th>
                  <th className="px-2 py-1 text-left font-medium text-slate-600">
                    {t('dashboard.movementsIn.col.product')}
                  </th>
                  <th className="px-2 py-1 text-right font-medium text-slate-600">
                    {t('dashboard.movementsIn.col.qty')}
                  </th>
                  <th className="px-2 py-1 text-left font-medium text-slate-600">
                    {t('dashboard.movementsIn.col.doc')}
                  </th>
                </tr>
              </thead>
              <tbody>
                {items.map((m) => (
                  <tr key={m.id} className="border-b border-slate-100 last:border-0">
                    <td className="px-2 py-1 text-slate-600">
                      {new Date(m.occurredAt).toLocaleDateString('it-IT')}
                    </td>
                    <td className="px-2 py-1 font-mono">{m.lotCode}</td>
                    <td className="px-2 py-1 text-slate-700">{m.productCode}</td>
                    <td className="px-2 py-1 text-right font-mono">
                      {Number(m.qty).toFixed(0)} g
                    </td>
                    <td className="px-2 py-1 text-slate-500">
                      {m.documentType ? `${m.documentType} ${m.documentCode ?? ''}` : '—'}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
